// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__z6H0z","question":"Question_question__21rb_","description":"Question_description__XqTUE"};